import React, { useEffect, useState } from "react";
import { Alert, Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import TrackingService from "../../services/trackingService";

export const Dispatcher = (props) => {

    const service = TrackingService();

    const [state, setState] = useState({
        vehicleId: 0,
        mobileNumber: "",
        drivers: []
    });

    const [token, setToken] = useState("");

    useEffect(() => {
        console.info("Dispatcher.useEffect", state);
        if(state?.drivers?.length === 0) {
            service.getDrivers().then(drivers => {
                console.info(drivers);
                setState({...state, drivers: drivers});
            });
        }
    });

    const handleChange = function(ev) {
        let fieldName = ev.target.name;
        let fleldVal = ev.target.value;
        setState({...state, [fieldName]: fleldVal})
    }

    const handleSubmit = function(ev) {
        ev.preventDefault();
        console.info("Dispatcher.handleSubmit", state);
        service.sendTrackingLink(state.vehicleId, state.mobileNumber).then(res => {
            setToken(res);
            setTimeout(() => {
                setToken("");
                setState({...state, 
                    vehicleId: 0,
                    mobileNumber: "",
                    drivers: []});
            }, 30000);
        }).catch(err => {
            console.error(err);
        });
    }

    return (
        <Row className="flex-fill mt-4">
            
            <Col >
            <h3 className="text-center">Send a tracking link</h3>
        <Form onSubmit={handleSubmit}>
        
            <Row className="justify-content-center align-items-center">
                <Col xs="auto">
                    <FloatingLabel controlId="floatingSelect" label="Driver">
                        <Form.Select 
                            defaultValue={state?.vehicleId}
                            onChange={handleChange}
                            name="vehicleId">
                            <option value="0">Choose...</option>
                            {state?.drivers?.map(driver => (
                                <option key={driver.id} disabled={!driver.staticAssignedVehicle} value={driver.staticAssignedVehicle?.id}>{driver.name}</option>
                            ))}
                        </Form.Select>
                    </FloatingLabel>
                </Col>
                <Col xs="auto">
                    <FloatingLabel controlId="MobileNunber" label="Mobile number">
                        <Form.Control name="mobileNumber" placeholder="Mobile number" onChange={handleChange} />
                    </FloatingLabel>
                </Col>
                <Col xs="auto">
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                </Col>
            </Row>
            <Row className="justify-content-center align-items-center m-3">
                <Col xs="auto">
                    <Alert variant="success" show={token} dismissible>
                        SMS sent with success. <br />
                        <Link to={`/public/${token}`}>Go to tracking</Link>
                    </Alert>
                </Col>
            </Row>
        </Form>
        
        </Col>
        </Row>
    );
};

